module.exports = __webpack_public_path__ + "assets/img/mecha-btn-ee1a8099.png";